<template>
  <!-- Full-screen editor mode (no layout) -->
  <div v-if="currentRoute.meta.layoutEmpty">
    <slot />
  </div>

  <!-- Normal layout with sidebar -->
  <div v-else class="flex h-screen">
    <!-- Sidebar -->
    <Sidebar />

    <!-- Main Window -->
    <div class="w-[calc(100vh-264px)] flex-grow overflow-hidden">
      <div class="h-2.5 w-full bg-sidebar"></div>

      <div
        class="relative h-[calc(100vh-12px)] overflow-y-auto rounded-tl-2xl bg-white pl-12 pr-12"
      >
        <div
          class="flex max-w-screen-2xl flex-1 flex-col px-8 py-6 lg:px-12 lg:py-12 xl:px-20 2xl:mx-auto"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

import Sidebar from '@/shared/theme/Sidebar/Sidebar.vue'

export default defineComponent({
    components: {
        Sidebar,
    },
    setup() {
        const { currentRoute } = useRouter()

        return { currentRoute }
    },
})
</script>
